// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3VCTY","itemTitle":"ClientEmergencyInfo_itemTitle__1_MUY","itemText":"ClientEmergencyInfo_itemText__zzr8d"};